import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Typography,
} from "@mui/material";
import logo from "../../assets/images/logo-drsaude.png";
import mobileSecondStep from "../../assets/images/second-step-mobile.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HttpsIcon from "@mui/icons-material/Https";
import { useStyles } from "./styles";
import theme from "../../theme";
import { AccordionDependent } from "../../components/AccordionOne";
import { DesktopInformations } from "../../components/DesktopInformations";
import { Paper } from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import { RequestedSummary } from "../../components/RequestedSummary";
import CheckIcon from "@mui/icons-material/Check";
import { Card } from "../../components/Card";
import { useLocation, useNavigate } from "react-router-dom";
import UsersService from "../../services/UsersService";
import Swal from "sweetalert2";
import TabsMethodPayment from "../../components/TabsMethodPayment";
import api from "../../services/api";
import { montarCorpoPixAutomatico } from "../../utils/montarCorpoPixAutomatico";
import { RespostaCadastroPixAutomatico } from "../../types/PixAutomaticoTypes";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

export interface IPlan {
  name: string;
  plan_code: string;
  value: number;
  registrations: number;
  value_formatted: string;
}

interface IDependent {
  name: string;
  phone: string;
  email: string;
  cpf: string;
  birthday: string;
  address: {
    zip_code: string;
    state: string;
    city: string;
    street: string;
    number: string;
    neighborhood: string;
    complement: string;
  };
}

interface ICPFLHolder {
  type: "pf" | "pj";
  uc: string;
  pn: string;
  reading_date: string;
  holder_name?: string;
  holder_phone?: string;
  holder_cellphone: string;
  holder_email: string;
  holder_birthday?: string;
  holder_document?: string;
  holder_rg?: string;
  zip_code: string;
  state: string;
  city: string;
  street: string;
  number: string;
  neighborhood: string;
  complement: string;
  cnpj?: string;
  inscricao_estadual?: string;
  nome_responsavel?: string;
  cpf_responsavel?: string;
  rg_responsavel?: string;
  data_abertura?: string;
  [key: string]: string | undefined;
}

export function Registration() {
  const classes = useStyles();
  const { state } = useLocation();
  const { data, manager_code, promotional, paymentType, linkType } =
    state || {};

  const getInitialRoute = () => {
    if (linkType === "1") {
      return "/black-friday";
    }
    if (linkType === "2") {
      return "/aniversario";
    }
    if (paymentType === "cpfl") {
      return "/cpfl";
    }
    if (paymentType === "boleto") {
      return "/boleto";
    }
    if (paymentType === "pix_automatico") {
      return "/pix-automatico";
    }
    if (promotional) {
      return "/promocional";
    }
    return "/";
  };
  const [openSummary, setOpenSummary] = useState<boolean>(false);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [dependentsSelected, setDependentsSelected] = useState<number>(0);
  const [valueSelected, setValueSelected] = useState<string>("29.90");
  const [acceptTerms, setAcceptTerms] = useState<boolean>(false);
  const [plans, setPlans] = useState<IPlan[]>([]);
  const navigate = useNavigate();
  const [value] = useState(paymentType || "credit_card");
  const [planNameSelected, setPlanNameSelected] = useState<string>("");
  const [planCodeSelected, setPlanCodeSelected] = useState<string>("plan0");
  const [validationForm, setValidationForm] = useState<boolean>(false);
  const [dependentValidations, setDependentValidations] = useState<boolean[]>(
    []
  );
  const billDueDate = localStorage.getItem("selectedDaysBoleto") || "5";
  const [planSelected, setPlanSelected] = useState<IPlan | null>(null);
  const [cardBrandError, setCardBrandError] = useState<string>("");

  const [payment, setPayment] = useState({
    card_holder_name: "",
    card_brand: "",
    card_cvv: "",
    card_year_expiration: "",
    card_month_expiration: "",
    card_number: "",
    plan_code: "",
    manager_code: manager_code,
    payment_type: paymentType || "credit_card",
    cpfl_holder: {
      type: "pf",
      uc: "",
      pn: "",
      reading_date: "",
      holder_name: "",
      holder_phone: "",
      holder_cellphone: "",
      holder_email: "",
      holder_birthday: "",
      holder_document: "",
      holder_rg: "",
      zip_code: "",
      state: "",
      city: "",
      street: "",
      number: "",
      neighborhood: "",
      complement: "",
      cnpj: "",
      inscricao_estadual: "",
      nome_responsavel: "",
      cpf_responsavel: "",
      rg_responsavel: "",
      data_abertura: "",
    },
  });

  const [dependents, setDependents] = useState<IDependent[]>([]);

  const handleDependentValidationChange = (index: number, isValid: boolean) => {
    setDependentValidations((prev) => {
      const newValidations = [...prev];
      newValidations[index] = isValid;
      return newValidations;
    });
  };

  useEffect(() => {
    if (plans.length > 0) {
      setPlanNameSelected(plans[0].name);
      setDependentsSelected(plans[0].registrations);
      setValueSelected(plans[0].value_formatted);
      setValidationForm(plans[0].registrations > 0);

      const initialValidations = new Array(plans[0].registrations).fill(false);
      setDependentValidations(initialValidations);
    }
  }, [plans]);

  const validationCard = !hasEmptyFields(payment);
  const changeFinalBody = (paymentToUse?: typeof payment) => {
    if (!data) return null;

    const currentPayment = paymentToUse || payment;

    const paymentBody =
      currentPayment?.payment_type === "cpfl" ||
      currentPayment?.payment_type === "boleto"
        ? {
            payment_type: currentPayment?.payment_type,
            plan_code: planCodeSelected,
            manager_code: manager_code,
            card_holder_name: null,
            card_brand: null,
            card_cvv: null,
            card_year_expiration: null,
            card_month_expiration: null,
            card_number: null,
            bill_due_date:
              currentPayment?.payment_type === "boleto" ? billDueDate : null,
            promotional: String(promotional),
            link_type: linkType || null,
          }
        : {
            payment_type: currentPayment?.payment_type,
            card_holder_name: currentPayment?.card_holder_name,
            card_brand: currentPayment?.card_brand,
            card_cvv: currentPayment?.card_cvv,
            card_year_expiration: currentPayment?.card_year_expiration,
            card_month_expiration: currentPayment?.card_month_expiration,
            card_number: currentPayment?.card_number?.replace(/[^0-9s]/g, ""),
            plan_code: planCodeSelected,
            manager_code: manager_code,
            bill_due_date: null,
            promotional: String(promotional),
            link_type: linkType || null,
          };

    const dependentBody = dependents.map((dependent) => ({
      name: dependent.name || "",
      phone: dependent.phone ? dependent.phone.replace(/[^0-9s]/g, "") : "",
      email: dependent.email || "",
      cpf: dependent.cpf ? dependent.cpf.replace(/[^0-9s]/g, "") : "",
      birthday: dependent.birthday
        ? dependent.birthday.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
        : "",
      address: {
        zip_code: dependent.address?.zip_code
          ? dependent.address.zip_code.replace(/[^0-9s]/g, "")
          : "",
        state: dependent.address?.state || "",
        city: dependent.address?.city || "",
        street: dependent.address?.street || "",
        number: dependent.address?.number || "",
        neighborhood: dependent.address?.neighborhood || "",
        complement: dependent.address?.complement || "",
      },
      plan_code: planCodeSelected,
    }));

    const body = {
      principal: {
        name: data?.name,
        phone: data?.phone.replace(/[^0-9s]/g, ""),
        email: data?.email,
        cpf: data?.cpf.replace(/[^0-9s]/g, ""),
        birthday: data?.birthday.replace(
          /(\d{2})\/(\d{2})\/(\d{4})/,
          "$3-$2-$1"
        ),
        address: {
          zip_code: data?.address?.zip_code.replace(/[^0-9s]/g, ""),
          state: data?.address?.state,
          city: data?.address?.city,
          street: data?.address?.street,
          number: data?.address?.number,
          neighborhood: data?.address?.neighborhood,
          complement: data?.address?.complement,
        },
        payment: paymentBody,
        ...(currentPayment?.payment_type === "cpfl" && {
          cpfl_holder: {
            type: currentPayment.cpfl_holder?.type,
            uc: currentPayment.cpfl_holder?.uc,
            pn: currentPayment.cpfl_holder?.pn,
            reading_date: currentPayment.cpfl_holder?.reading_date,
            holder_name: currentPayment.cpfl_holder?.holder_name,
            holder_phone: currentPayment.cpfl_holder?.holder_phone?.replace(
              /[^0-9s]/g,
              ""
            ),
            holder_cellphone:
              currentPayment.cpfl_holder?.holder_cellphone?.replace(
                /[^0-9s]/g,
                ""
              ),
            holder_email: currentPayment.cpfl_holder?.holder_email,
            holder_birthday: currentPayment.cpfl_holder?.holder_birthday
              ? currentPayment.cpfl_holder.holder_birthday.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  "$3-$2-$1"
                )
              : "",
            holder_document:
              currentPayment.cpfl_holder?.holder_document?.replace(
                /[^0-9s]/g,
                ""
              ),
            holder_rg: currentPayment.cpfl_holder?.holder_rg?.replace(
              /[^0-9s]/g,
              ""
            ),
            zip_code: currentPayment.cpfl_holder?.zip_code?.replace(
              /[^0-9s]/g,
              ""
            ),
            state: currentPayment.cpfl_holder?.state,
            city: currentPayment.cpfl_holder?.city,
            street: currentPayment.cpfl_holder?.street,
            number: currentPayment.cpfl_holder?.number,
            neighborhood: currentPayment.cpfl_holder?.neighborhood,
            complement: currentPayment.cpfl_holder?.complement,
            cnpj: currentPayment.cpfl_holder?.cnpj?.replace(/[^0-9s]/g, ""),
            inscricao_estadual: currentPayment.cpfl_holder?.inscricao_estadual,
            nome_responsavel: currentPayment.cpfl_holder?.nome_responsavel,
            cpf_responsavel:
              currentPayment.cpfl_holder?.cpf_responsavel?.replace(
                /[^0-9s]/g,
                ""
              ),
            rg_responsavel: currentPayment.cpfl_holder?.rg_responsavel.replace(
              /[^0-9s]/g,
              ""
            ),
            data_abertura: currentPayment.cpfl_holder?.data_abertura
              ? currentPayment.cpfl_holder.data_abertura.replace(
                  /(\d{2})\/(\d{2})\/(\d{4})/,
                  "$3-$2-$1"
                )
              : "",
          },
        }),
      },
      dependentes: dependentBody,
    };

    return body;
  };
  function hasEmptyFields(data: any) {
    if (data.payment_type !== "credit_card") {
      return false;
    }

    const requiredFields = [
      "card_holder_name",
      "card_cvv",
      "card_year_expiration",
      "card_month_expiration",
      "card_number",
      "card_brand",
    ];

    for (const key of requiredFields) {
      if (
        !data[key] ||
        (typeof data[key] === "string" && data[key].trim() === "")
      ) {
        return true;
      }
    }

    return false;
  }

  function getCardBrand(cardNumber: any): string {
    if (!cardNumber) {
      return "";
    }

    const cardNumberString = cardNumber.toString().replace(/\D/g, "");

    if (!cardNumberString || cardNumberString.length < 4) {
      return "";
    }

    // Visa: começa com 4
    if (cardNumberString.startsWith("4")) {
      return "visa";
    }
    
    // MasterCard: começa com 5 (51-55) ou 2221-2720
    if (cardNumberString.startsWith("5")) {
      const firstTwoDigits = parseInt(cardNumberString.substring(0, 2));
      if (firstTwoDigits >= 51 && firstTwoDigits <= 55) {
        return "MasterCard";
      }
    }
    // MasterCard: intervalo 2221-2720
    if (cardNumberString.length >= 4) {
      const firstFourDigits = parseInt(cardNumberString.substring(0, 4));
      if (firstFourDigits >= 2221 && firstFourDigits <= 2720) {
        return "MasterCard";
      }
    }
    
    // American Express: começa com 34 ou 37
    if (cardNumberString.match(/^3[47]/)) {
      return "American Express";
    }
    
    // Discover: começa com 6 ou 6011
    if (cardNumberString.startsWith("6")) {
      return "Discover";
    }
    
    return "";
  }

  function identifyCardBrand(cardNumber: any) {
    const brand = getCardBrand(cardNumber);

    const cardNumberClean = cardNumber?.toString().replace(/\D/g, "") || "";
    if (cardNumberClean.length >= 4 && !brand) {
      setCardBrandError(
        "Bandeira do cartão não identificada. Aceitamos apenas Visa, MasterCard, American Express ou Discover."
      );
    } else if (cardNumberClean.length >= 4 && brand) {
      setCardBrandError("");
    } else if (cardNumberClean.length < 4) {
      setCardBrandError("");
    }

    setPayment((prev) => ({ ...prev, card_brand: brand }));
  }

  const validatePaymentByType = () => {
    switch (payment?.payment_type) {
      case "credit_card":
        return validationCard;
      case "boleto":
        return true;
      case "pix_automatico":
        return true;
      case "cpfl":
        if (!payment?.cpfl_holder) return false;
        const cpflHolder = payment.cpfl_holder as ICPFLHolder;
        const type = cpflHolder.type;

        const commonRequired = [
          "uc",
          "pn",
          "holder_cellphone",
          "holder_email",
          "zip_code",
          "state",
          "city",
          "street",
          "number",
          "neighborhood",
        ] as const;

        const commonFieldsValid = commonRequired.every((field) => {
          const value = cpflHolder[field];
          return value !== undefined && value !== null && value.trim() !== "";
        });

        if (!commonFieldsValid) return false;

        if (type === "pf") {
          const pfRequired = [
            "holder_name",
            "holder_birthday",
            "holder_document",
            "holder_rg",
          ] as const;
          return pfRequired.every((field) => {
            const value = cpflHolder[field];
            return value !== undefined && value !== null && value.trim() !== "";
          });
        }

        if (type === "pj") {
          const pjRequired = [
            "cnpj",
            "inscricao_estadual",
            "nome_responsavel",
            "cpf_responsavel",
            "rg_responsavel",
            "data_abertura",
          ] as const;
          return pjRequired.every((field) => {
            const value = cpflHolder[field];
            return value !== undefined && value !== null && value.trim() !== "";
          });
        }

        return false;
      default:
        return false;
    }
  };

  useEffect(() => {
    const validateBody = () => {
      const isPaymentValid =
        payment?.payment_type === "boleto" ||
        payment?.payment_type === "cpfl" ||
        payment?.payment_type === "pix_automatico"
          ? true
          : validationCard;

      let isFormValid = true;

      if (payment?.payment_type === "cpfl" && payment?.cpfl_holder) {
        const cpflHolder = payment.cpfl_holder as ICPFLHolder;
        const type = cpflHolder.type;

        const commonRequired = [
          "uc",
          "pn",
          "holder_cellphone",
          "holder_email",
        ] as const;

        for (const field of commonRequired) {
          const value = cpflHolder[field];
          if (!value || value.trim() === "") {
            isFormValid = false;
            break;
          }
        }

        if (type === "pf") {
          const pfRequired = [
            "holder_name",
            "holder_birthday",
            "holder_document",
            "holder_rg",
          ] as const;
          for (const field of pfRequired) {
            const value = cpflHolder[field];
            if (!value || value.trim() === "") {
              isFormValid = false;
              break;
            }
          }
        } else if (type === "pj") {
          const pjRequired = [
            "cnpj",
            "inscricao_estadual",
            "nome_responsavel",
            "cpf_responsavel",
            "rg_responsavel",
            "data_abertura",
          ] as const;
          for (const field of pjRequired) {
            const value = cpflHolder[field];
            if (!value || value.trim() === "") {
              isFormValid = false;
              break;
            }
          }
        }
      }

      if (dependentsSelected > 0) {
        const allDependentsValid =
          dependentValidations.length > 0 &&
          dependentValidations.every((validation) => validation === true);
        isFormValid = isFormValid && allDependentsValid;
      }

      if (
        acceptTerms &&
        dependentsSelected >= 0 &&
        isPaymentValid &&
        isFormValid
      ) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    };

    validateBody();
  }, [
    dependentsSelected,
    validationForm,
    dependentValidations,
    acceptTerms,
    validationCard,
    payment?.payment_type,
    payment?.cpfl_holder,
  ]);

  useEffect(() => {
    if (payment?.payment_type === "credit_card") {
      if (payment?.card_number && payment.card_number.trim() !== "") {
        identifyCardBrand(payment.card_number);
      } else {
        setPayment((prev) => ({ ...prev, card_brand: "" }));
        setCardBrandError("");
      }
    } else {
      setCardBrandError("");
    }
  }, [payment?.card_number, payment?.payment_type]);

  async function handleSubmit() {
    let paymentToUse = payment;

    if (payment?.payment_type === "pix_automatico") {
      setLoading(true);

      const corpoPix = montarCorpoPixAutomatico(
        {
          name: data?.name,
          phone: data?.phone,
          email: data?.email,
          cpf: data?.cpf,
          birthday: data?.birthday,
          address: data?.address,
        },
        dependents,
        planCodeSelected,
        manager_code || null
      );

      try {
        const { data: resposta } = await UsersService.criarPixAutomatico(
          corpoPix
        );
        const dadosPix = resposta as RespostaCadastroPixAutomatico;

        if (dadosPix.status === true) {
          navigate("/pagamento", {
            state: {
              data: corpoPix,
              transaction: dadosPix.transaction_code,
              planSelected: planSelected,
              firstSegment: promotional,
              linkType: linkType,
              paymentType: "pix_automatico",
              pagamentoPix: dadosPix.pagamento,
              mensagemPix: dadosPix.message,
            },
          });
        }
      } catch (error: any) {
        Swal.fire({
          title:
            error?.response?.data?.message || "Erro ao processar o cadastro",
          icon: "error",
          showConfirmButton: false,
          timer: 5000,
        });
      } finally {
        setLoading(false);
      }
      return;
    }

    if (payment?.payment_type === "credit_card") {
      let currentBrand = payment.card_brand;
      if (!currentBrand || currentBrand.trim() === "") {
        currentBrand = getCardBrand(payment.card_number);
        if (currentBrand) {
          setPayment((prev) => ({ ...prev, card_brand: currentBrand }));
          paymentToUse = { ...payment, card_brand: currentBrand };
        }
      }

      if (!currentBrand || currentBrand.trim() === "") {
        Swal.fire({
          title:
            "Por favor, verifique o número do cartão. A bandeira não foi identificada. Aceitamos apenas Visa, MasterCard, American Express ou Discover.",
          icon: "error",
          showConfirmButton: true,
          timer: 5000,
        });
        return;
      }
    }

    setLoading(true);

    const body = changeFinalBody(paymentToUse);

    if (!body) {
      Swal.fire({
        title: "Erro ao processar os dados",
        icon: "error",
        showConfirmButton: true,
        timer: 5000,
      });
      setLoading(false);
      return;
    }

    if (
      paymentToUse?.payment_type === "credit_card" &&
      (!body?.principal?.payment?.card_brand ||
        body.principal.payment.card_brand.trim() === "")
    ) {
      Swal.fire({
        title: "O campo card brand é obrigatório.",
        icon: "error",
        showConfirmButton: true,
        timer: 5000,
      });
      setLoading(false);
      return;
    }

    let pagamentoEnviado = false;

    try {
      const { data } = await UsersService.create(body);
      if (data.status === true) {
        pagamentoEnviado = paymentToUse?.payment_type === "credit_card";
        navigate("/pagamento", {
          state: {
            data: body,
            transaction: data?.transaction_code,
            planSelected: planSelected,
            firstSegment: promotional,
            linkType: linkType,
          },
        });
      }
    } catch (error: any) {
      Swal.fire({
        title:
          error?.response?.data?.message || "Erro ao processar o pagamento",
        icon: "error",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      if (!pagamentoEnviado) {
        setLoading(false);
      }
    }
  }

  const handleCheckboxChange = () => {
    setAcceptTerms(!acceptTerms);
  };

  const getPlansOptions = async () => {
    try {
      const data = await api.get("/api/user/onboarding/list/plans");
      setPlans(data.data);
      if (data.data && data.data.length > 0) {
        setPlanSelected(data.data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPlansOptions();
  }, []);

  const filteredPlans =
    plans.length > 0 && (linkType === "1" || linkType === "2")
      ? plans.slice(0, 2)
      : plans;

  const getSlidesPerView = (defaultValue: number) => {
    if ((linkType === "1" || linkType === "2") && filteredPlans.length <= 2) {
      return filteredPlans.length;
    }
    return defaultValue;
  };

  useEffect(() => {
    if ((linkType === "1" || linkType === "2") && plans.length > 0) {
      const filteredPlansForCheck = plans.slice(0, 2);

      if (
        !planSelected ||
        !filteredPlansForCheck.some(
          (plan) => plan.plan_code === planSelected.plan_code
        )
      ) {
        if (filteredPlansForCheck.length > 0) {
          setPlanSelected(filteredPlansForCheck[0]);
          setPlanCodeSelected(filteredPlansForCheck[0].plan_code);
          setPlanNameSelected(filteredPlansForCheck[0].name);
          setValueSelected(filteredPlansForCheck[0].value_formatted);
          setDependentsSelected(filteredPlansForCheck[0].registrations);
        }
      }
    }
  }, [linkType, plans]);

  const handlePlanSelection = (planCode: string) => {
    setPlanCodeSelected(planCode);

    const selectedPlan = plans.find((plan) => plan.plan_code === planCode);
    if (selectedPlan) {
      const dependentArray: IDependent[] = Array.from(
        { length: selectedPlan.registrations },
        () => ({
          name: "",
          phone: "",
          email: "",
          cpf: "",
          birthday: "",
          address: {
            zip_code: "",
            state: "",
            city: "",
            street: "",
            number: "",
            neighborhood: "",
            complement: "",
          },
        })
      );
      setDependents(dependentArray);
      const initialValidations = new Array(selectedPlan.registrations).fill(
        false
      );
      setDependentValidations(initialValidations);
    }
  };

  const handleNameSelection = (planName: string) => {
    setPlanNameSelected(planName);
  };

  useEffect(() => {
    const data = {
      dependents: String(dependentsSelected) ?? "",
      value: valueSelected ?? "",
      paymentType: payment?.payment_type ?? "",
      planNameSelected: planNameSelected ?? "",
    };

    localStorage.setItem("selectedPlan", JSON.stringify(data));
  }, [
    dependentsSelected,
    valueSelected,
    payment?.payment_type,
    planNameSelected,
  ]);

  const processandoPagamento =
    loading && payment?.payment_type === "credit_card";

  return (
    <>
      <Backdrop
        open={processandoPagamento}
        sx={{
          color: "#fff",
          zIndex: (muiTheme) => muiTheme.zIndex.modal + 1,
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <CircularProgress color="inherit" />
        <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
          Processando o pagamento...
        </Typography>
      </Backdrop>
      {openSummary ? (
        <Slide
          direction="right"
          in
          mountOnEnter
          unmountOnExit
        >
          <Paper elevation={4}>
            <RequestedSummary
              planSelected={planSelected}
              setOpenSummary={setOpenSummary}
              holderName={data?.name ?? ""}
              holderCpf={data?.cpf ?? ""}
              holderPhone={data?.phone ?? ""}
              holderEmail={data?.email ?? ""}
              holderAddress={data?.address.street ?? ""}
              holderCep={data?.address.zip_code ?? ""}
              dependents={String(dependentsSelected) ?? ""}
              value={valueSelected ?? ""}
              paymentType={payment?.payment_type}
              planNameSelected={planNameSelected ?? ""}
              linkType={linkType}
            />
          </Paper>
        </Slide>
      ) : (
        <Box className={classes.container}>
          <Box className={classes.header}>
            <Box className={classes.wrapperInfo}>
              <Box className={classes.containerSteps}>
                <Box className={classes.containerCircle}>
                  <Box className={classes.circleOutlined}>
                    <Box>
                      <CheckIcon
                        style={{ color: theme.palette.primary.main }}
                      />
                    </Box>
                  </Box>
                  <Typography
                    className={classes.textStep}
                    style={{ color: "#908F8F", fontWeight: 500 }}
                  >
                    Cadastro
                  </Typography>
                </Box>
                <Box className={classes.containerCircle}>
                  <Box className={classes.circle}>
                    <Typography className={classes.circleText}>2</Typography>
                  </Box>
                  <Typography className={classes.textStep}>
                    Forma de pagamento
                  </Typography>
                </Box>
                <Box className={classes.containerCircle}>
                  <Box className={classes.circleOutlined}>
                    <Typography className={classes.circleTextOutlined}>
                      3
                    </Typography>
                  </Box>
                  <Typography
                    className={classes.textStep}
                    style={{ color: "#908F8F", fontWeight: 500 }}
                  >
                    Comprovante de ativação
                  </Typography>
                </Box>
              </Box>
              <img
                src={logo}
                alt="Logo Dr Saude"
                className={classes.logo}
              />
              <Box
                className={classes.retangleOrder}
                onClick={() => setOpenSummary(true)}
              >
                <Typography className={classes.textOrder}>
                  Resumo do pedido
                </Typography>
                <KeyboardArrowDownIcon
                  style={{ color: theme.palette.text.primary }}
                />
              </Box>
            </Box>
            <Box className={classes.containerEnvinroment}>
              <Typography className={classes.textSecurity}>
                <HttpsIcon
                  style={{ width: "16px", color: theme.palette.text.secondary }}
                />
                ambiente seguro
              </Typography>
            </Box>
            <Box className={classes.wrapperStep}>
              <img
                src={mobileSecondStep}
                alt="Etapa da tela"
              />
            </Box>
          </Box>
          <Box className={classes.containerColumns}>
            <Box className={classes.box}>
              <TabsMethodPayment
                promotional={promotional}
                payment={payment}
                setPayment={setPayment}
                value={value}
                handleChange={() => {}}
                cardBrandError={cardBrandError}
              />
              <Box className={classes.planOptions}>
                <Typography className={classes.boxTitle}>
                  Opções de planos
                </Typography>
                <Box className={classes.separator} />
                <Box
                  className={classes.containerCardsDependents}
                  sx={{
                    ...((linkType === "1" || linkType === "2") &&
                      filteredPlans.length <= 2 && {
                        justifyContent: "flex-start",
                        gap: "40px",
                      }),
                  }}
                >
                  <Swiper
                    modules={[Scrollbar]}
                    slidesPerView={getSlidesPerView(3)}
                    scrollbar={{ draggable: true }}
                    style={{
                      paddingBottom: "30px",
                      paddingTop: "10px",
                      display: "flex",
                      ...((linkType === "1" || linkType === "2") &&
                        filteredPlans.length <= 2 && {
                          justifyContent: "flex-start",
                        }),
                    }}
                    direction="horizontal"
                    breakpoints={{
                      1130: {
                        slidesPerView: getSlidesPerView(2),
                        spaceBetween:
                          (linkType === "1" || linkType === "2") &&
                          filteredPlans.length <= 2
                            ? 30
                            : 10,
                      },
                      1470: {
                        slidesPerView: getSlidesPerView(3),
                        spaceBetween:
                          (linkType === "1" || linkType === "2") &&
                          filteredPlans.length <= 2
                            ? 40
                            : 10,
                      },
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                    }}
                  >
                    {filteredPlans && filteredPlans.length > 0
                      ? filteredPlans.map((plan) => (
                          <SwiperSlide
                            key={plan.plan_code}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              height: "100%",
                              ...((linkType === "1" || linkType === "2") &&
                                filteredPlans.length <= 2 && {
                                  maxWidth: "350px",
                                  minWidth: "300px",
                                }),
                            }}
                          >
                            <Card
                              plan={plan}
                              setPlanSelected={setPlanSelected}
                              dependents={plan?.registrations}
                              value={plan?.value_formatted}
                              dependentsSelected={dependentsSelected}
                              setDependentsSelected={setDependentsSelected}
                              setValueSelected={setValueSelected}
                              name={plan?.name}
                              handlePlanSelection={handlePlanSelection}
                              handleNameSelection={handleNameSelection}
                              planCode={plan?.plan_code}
                              selectedPlanCode={planCodeSelected}
                              setSelectedPlanCode={setPlanCodeSelected}
                              isBlackFriday={
                                (linkType === "1" || linkType === "2") &&
                                filteredPlans.length <= 2
                              }
                            />
                          </SwiperSlide>
                        ))
                      : null}
                  </Swiper>
                </Box>
                <Box className={classes.containerCardsDependentsMobile}>
                  <Swiper
                    style={{
                      paddingBottom: "30px",
                      paddingTop: "10px",
                      display: "flex",
                    }}
                    modules={[Scrollbar]}
                    slidesPerView={1}
                    spaceBetween={10}
                    scrollbar={{ draggable: true }}
                    direction="horizontal"
                  >
                    {filteredPlans && filteredPlans.length > 0
                      ? filteredPlans.map((plan) => (
                          <SwiperSlide
                            key={plan.plan_code}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <Card
                              plan={plan}
                              setPlanSelected={setPlanSelected}
                              dependents={plan?.registrations}
                              value={plan?.value_formatted}
                              dependentsSelected={dependentsSelected}
                              setDependentsSelected={setDependentsSelected}
                              setValueSelected={setValueSelected}
                              name={plan?.name}
                              handlePlanSelection={handlePlanSelection}
                              handleNameSelection={handleNameSelection}
                              planCode={plan?.plan_code}
                              selectedPlanCode={planCodeSelected}
                              setSelectedPlanCode={setPlanCodeSelected}
                            />
                          </SwiperSlide>
                        ))
                      : null}
                  </Swiper>
                </Box>

                <Box className={classes.containerAccordions}>
                  {dependents.length > 0 &&
                    dependents.map((dependent, index) => (
                      <AccordionDependent
                        key={index}
                        index={index}
                        body={dependent}
                        setBody={(newBody: Partial<IDependent>) => {
                          setDependents((prevDependents) =>
                            prevDependents.map((dep, i) =>
                              i === index
                                ? {
                                    ...dep,
                                    ...newBody,
                                    address: {
                                      ...dep.address,
                                      ...newBody.address,
                                    },
                                  }
                                : dep
                            )
                          );
                        }}
                        onValidationChange={handleDependentValidationChange}
                        searchPostalCode={async () => {
                          if (
                            dependent.address?.zip_code &&
                            dependent.address.zip_code.replace(/\D/g, "")
                              .length === 8
                          ) {
                            try {
                              const cleanZipCode =
                                dependent.address.zip_code.replace(/\D/g, "");
                              const response = await fetch(
                                `https://viacep.com.br/ws/${cleanZipCode}/json/`
                              );
                              const data = await response.json();

                              if (!data.erro) {
                                setDependents((prevDependents) =>
                                  prevDependents.map((dep, i) =>
                                    i === index
                                      ? {
                                          ...dep,
                                          address: {
                                            ...dep.address,
                                            zip_code: data.cep,
                                            street: data.logradouro,
                                            neighborhood: data.bairro,
                                            city: data.localidade,
                                            state: data.uf,
                                          },
                                        }
                                      : dep
                                  )
                                );
                              }
                            } catch (error) {
                              console.error("Erro ao buscar o CEP:", error);
                            }
                          }
                        }}
                      />
                    ))}
                </Box>

                <Box className={classes.containerCheckbox}>
                  <Checkbox
                    checked={acceptTerms}
                    onChange={handleCheckboxChange}
                  />
                  <label>Li e aceito o </label>
                  <a
                    href="https://api.drsaudeapp.com.br/uploads/info/Contrato-Vialux.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    contrato de aquisição dos serviços
                  </a>
                </Box>

                <Box className={classes.containerCheckbox}>
                  <Checkbox checked={true} />
                  <label>Retirada do cartão Dr. Saúde</label>
                </Box>

                <Box className={classes.containerCardDrSaude}>
                  <p>
                    <strong>Retirada na Central:</strong> O cliente deverá
                    comparecer ao local Doutor Saúde, localizado na Avenida
                    Presidente Juscelino Kubitschek de Oliveira, 625 - Centro,
                    Sorocaba, nos seguintes horários de atendimento:
                  </p>

                  <strong>
                    <li>🕒 Segunda a Sexta: 08h00 às 18h00</li>
                    <li>🕒 Sábado: 08h00 às 12h00</li>
                  </strong>
                  <Box className={classes.containerHours}>
                    <p>
                      <strong>
                        📄 Documentos necessários para retirada na central:
                      </strong>{" "}
                      Documento com foto
                    </p>
                  </Box>
                </Box>

                <Box className={classes.containerButton}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: theme.palette.primary.dark,
                      color: "#FFF",
                      fontSize: "18px",
                      marginTop: {
                        xs: "0px",
                        md: "30px",
                      },
                    }}
                    className={classes.button}
                    disabled={disabled || loading}
                    onClick={handleSubmit}
                  >
                    {processandoPagamento ? "Processando..." : "Continuar"}
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      borderColor: theme.palette.primary.dark,
                      color: theme.palette.primary.dark,
                      fontSize: "18px",
                      marginTop: "10px",
                    }}
                    className={classes.button}
                    disabled={processandoPagamento}
                    onClick={() => {
                      const route = getInitialRoute();
                      navigate(route, {
                        state: {
                          planSelected: planSelected,
                          data: {
                            ...data,
                            dependents: dependents,
                            payment: payment,
                            planCodeSelected: planCodeSelected,
                            planNameSelected: planNameSelected,
                            dependentsSelected: dependentsSelected,
                            valueSelected: valueSelected,
                          },
                          manager_code: manager_code,
                        },
                      });
                    }}
                  >
                    Voltar
                  </Button>
                </Box>
              </Box>
            </Box>
            <DesktopInformations
              firstSegment={promotional}
              planSelected={planSelected}
              setOpenSummary={setOpenSummary}
              holderName={data?.name ?? ""}
              holderCpf={data?.cpf ?? ""}
              holderPhone={data?.phone ?? ""}
              holderEmail={data?.email ?? ""}
              holderAddress={data?.address.street ?? ""}
              holderCep={data?.address.zip_code ?? ""}
              dependents={String(dependentsSelected) ?? ""}
              value={valueSelected ?? ""}
              paymentType={payment?.payment_type}
              planNameSelected={planNameSelected ?? ""}
              linkType={linkType}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
